import PageHeader from '@/components/feature/PageHeader';
import Solutions from './components/Solutions';

export default function SolutionsPage() {
  return (
    <>
      <PageHeader
        title="Nos Solutions"
        subtitle="Du conteneur complet au groupage, des transactions de fonds à la livraison porte-à-porte — nous couvrons l'ensemble de votre chaîne logistique Chine–RDC."
        image="https://readdy.ai/api/search-image?query=Rows%20of%20colorful%20shipping%20containers%20stacked%20at%20modern%20logistics%20port%20with%20container%20ship%20in%20background%2C%20warm%20golden%20hour%20light%2C%20clean%20industrial%20maritime%20scene%2C%20editorial%20photography%2C%20professional%20freight%20forwarding%20imagery%20high%20detail&width=1800&height=800&seq=gls-page-solutions&orientation=landscape"
      />
      <Solutions />
    </>
  );
}